/** Home card art (the art carries the meaning; most players do not read yet). */
export function SpillCardArt() {
  return (
    <svg viewBox="0 0 320 200" className="absolute inset-0 h-full w-full" preserveAspectRatio="xMidYMid slice">
      <defs>
        <linearGradient id="spill-sky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#bfe3f7" />
          <stop offset="1" stopColor="#e9f5fb" />
        </linearGradient>
      </defs>
      <rect width="320" height="200" fill="url(#spill-sky)" />
      {/* dunes */}
      <path d="M0 150 C 50 120, 90 125, 130 140 S 220 165, 320 132 L320 200 L0 200 Z" fill="#ecd9b4" />
      <path d="M0 172 C 70 150, 140 160, 200 172 S 280 182, 320 168 L320 200 L0 200 Z" fill="#e2cca3" />
      {/* hill with a crater */}
      <path d="M40 150 L 105 62 L 118 70 L 132 62 L 196 150 Z" fill="#e6d1a9" />
      {/* streams pouring from the sky */}
      <g style={{ mixBlendMode: 'multiply' }}>
        <rect x="112" y="0" width="9" height="66" rx="4" fill="#ff9500" opacity="0.85" />
        <rect x="232" y="0" width="9" height="104" rx="4" fill="#32ade6" opacity="0.85" />
        <rect x="252" y="0" width="7" height="104" rx="3.5" fill="#ffcc00" opacity="0.9" />
        {/* the overflow running down the hill */}
        <path d="M128 68 C 140 90, 150 110, 170 140" stroke="#ff9500" strokeWidth="8" fill="none" strokeLinecap="round" opacity="0.8" />
        {/* layered pool in a glass jar */}
        <rect x="220" y="104" width="52" height="16" fill="#af52de" opacity="0.6" />
        <rect x="220" y="120" width="52" height="14" fill="#32ade6" opacity="0.7" />
        <rect x="220" y="134" width="52" height="12" fill="#ffcc00" opacity="0.75" />
        <rect x="220" y="146" width="52" height="12" fill="#ff3b30" opacity="0.7" />
        <ellipse cx="170" cy="150" rx="34" ry="9" fill="#ff9500" opacity="0.6" />
      </g>
      <rect x="216" y="84" width="60" height="76" rx="4" fill="none" stroke="#ffffff" strokeWidth="4" opacity="0.9" />
    </svg>
  )
}
